<template>
    <div>
        <h1>抽選ページ</h1>
        <v-container>
            <v-card>
                <v-card-title>{{ name }}</v-card-title>
            </v-card>
        </v-container>
        <v-container>
            <v-card-title>{{ winner }}</v-card-title>
            <v-btn @click="start">Start</v-btn>
            <v-btn @click="stop">Stop</v-btn>
        </v-container>
    </div>
</template>
<script>
    import firebase from 'firebase'
    export default {
        data() {
            return {
                userId: "",
                id: "",
                name: "",
                newItem: {
                    name: "",
                    count: 0
                },
                participants: [],
                winner: "",
                interval: 0
            }
        },
        methods: {
            stop: function(){
                clearInterval(this.interval);
            },
            start: function(){
                const self = this
                self.winner = 
                        self.participants[
                            Math.floor(Math.random() * Math.floor(self.participants.length))
                        ].name
                this.interval = setInterval(function(){
                    self.winner = 
                        self.participants[
                            Math.floor(Math.random() * Math.floor(self.participants.length))
                        ].name
                }, 100)
            }
        },
        async mounted() {
            const self = this;
            const user = firebase.auth().currentUser
            this.userId = user.uid
            const db = firebase.firestore()
            const userRef = db.collection("users").doc(user.uid)
            const eventRef = userRef.collection("events").doc(this.$route.params.id)
            this.id = eventRef.id
            const eventData = await eventRef.get()
            this.name = eventData.data().name

            //参加者一覧取得
            const participantsRef = eventRef.collection("participants")
            participantsRef.onSnapshot(function(querySnapshot) {
                self.participants = []
                querySnapshot.forEach(function(doc) {
                    self.participants.push({
                        id: doc.id,
                        name: doc.data().name
                    })
                })
            })
        }
    }

</script>